import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Pipe({ name: 'sdSafeUrl', standalone: true })
export class SafeUrlPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(url: string | any[]): SafeUrl {
    if (typeof url === 'string') {
      return this.domSanitizer.bypassSecurityTrustUrl(url);
    }

    return url;
  }
}
